import { render, staticRenderFns } from "./Lei.vue?vue&type=template&id=4c128d31&scoped=true&lang=pug"
import script from "./Lei.vue?vue&type=script&lang=js"
export * from "./Lei.vue?vue&type=script&lang=js"
import style0 from "./Lei.styl?vue&type=style&index=0&id=4c128d31&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c128d31",
  null
  
)

export default component.exports